import { CanDeactivateFn } from '@angular/router';
import type { UtilityReadingBatchComponent } from './utility-reading-batch.component';

/** Незаписани показания или запис/финализиране в движение — напускането пита (#299). */
export const readingBatchGuard: CanDeactivateFn<UtilityReadingBatchComponent> = (component) =>
  component.canLeave();
